<template>
  <v-container class="beginnings-page">
    <div class="beginnings-return">
      <v-btn class="beginnings-return__button" dark outlined large @click="returnToPreviousPage">
        <v-icon left>mdi-arrow-left</v-icon>
        {{ returnLabel }}
      </v-btn>
    </div>
    <div class="fade"></div>
    <div class="star-wars">
      <div class="crawl">
        <div class="crawl-title">
          <p>The Reckoning</p>
          <h1>Our Story</h1>
        </div>
        <p class="pb-12">Every crew has an origin story. Ours began at a pretty unusual moment.</p>
        <p class="pb-12">In a world suddenly forced apart, a small group of engineers came together around a simple idea: build the kind of company they actually wanted to be part of.</p>
        <p class="pb-12">A company built around talented people. A place where curiosity was encouraged, ideas could come from anywhere, and engineers had the freedom to learn, grow, and take ownership of what they built. A company where doing great work and building great relationships didn't have to be competing priorities.</p>
        <p class="pb-12">So they did what engineers do when something they want doesn't exist.</p>
        <p class="origin-story-emphasis pb-12">They built it.</p>
        <p class="origin-story-emphasis pb-12">And they called it Reckon.</p>
        <p class="pb-12">What started with a handful of people has grown into a Crew with different backgrounds, different perspectives, and a remarkable collection of super powers. Along the way, we've added new people, new capabilities, new traditions, new adventures, and more than a few stories worth telling.</p>
        <p class="pb-12">The company has grown, but the idea at the center of it hasn't changed: <strong>bring exceptional people together, invest in them, trust them, and see what they can accomplish.</strong></p>
        <p class="pb-12">The rest of the story?</p>
        <p class="origin-story-ending">We're still writing it.</p>
      </div>
    </div>
  </v-container>
</template>
<script>
export default {
  name: 'BeginningsView',
  data: () => ({
    returnLabel: 'Return Home',
    returnPath: '/',
  }),
  beforeRouteEnter(to, from, next) {
    const cameFromAnotherPage = Boolean(from.name) && from.name !== to.name;
    const pageTitle = from.meta?.title?.split('|')[0].trim();
    const returnPath = cameFromAnotherPage ? from.fullPath : '/';
    let returnLabel = 'Return Home';

    if (cameFromAnotherPage) {
      if (from.name === 'home') {
        returnLabel = 'Return Home';
      } else {
        returnLabel = pageTitle ? `Return to ${pageTitle}` : 'Return to previous page';
      }
    }

    next((vm) => {
      vm.configureReturn(returnPath, returnLabel);
    });
  },
  methods: {
    configureReturn(returnPath, returnLabel) {
      this.returnPath = returnPath;
      this.returnLabel = returnLabel;
    },
    returnToPreviousPage() {
      this.$router.push(this.returnPath);
    },
  },
};
</script>
<style>
  .beginnings-return {
    left: clamp(20px, 4vw, 56px);
    position: fixed;
    top: 88px;
    z-index: 2;
  }
  .beginnings-return__button.v-btn {
    backdrop-filter: blur(8px);
    background: rgba(5, 5, 5, .82);
    border-color: #666;
  }
  .star-wars {
    /* Flexbox to center the entire element on the screen */
    display: flex;
    justify-content: center;
    /* This is a magic number based on the context in which this snippet is used and effects the perspective */
    height: 200px;
    /* This sets allows us to transform the text on a 3D plane, and is somewhat a magic number */
    perspective: 400px;
    /* The rest is totally up to personal styling preferences */
    color: #feda4a;
    font-family: 'Pathway Gothic One', sans-serif;
    font-size: 350%;
    font-weight: 600;
    /* letter-spacing: 6px; */
    line-height: 150%;
    text-align: justify;
  }
  @media (max-width: 750px) {
    .beginnings-return {
      left: 16px;
      top: 72px;
    }
    .beginnings-return__button.v-btn {
      font-size: .72rem;
    }
    .star-wars {
      font-size: 300%;
    }
  }
  .crawl {
    /* Position the element so we can adjust the top property in the animation */
    position: relative;
    /* Defines the skew origin at the very center when we apply transforms on the animation */
    transform-origin: 50% 100%;
    /* Adds the crawl animation, which plays for one minute */
    animation: crawl 60s linear infinite;
    top: 99999px;
  }
  .crawl > .crawl-title {
    font-size: 90%;
    text-align: center;
  }
  .crawl > .crawl-title h1 {
    margin: 0 0 100px;
    text-transform: uppercase;
  }
  .origin-story-emphasis {
    font-size: 1.1em;
    font-weight: 700;
  }
  .origin-story-ending {
    font-size: 1.1em;
    font-style: italic;
    font-weight: 700;
  }
  @keyframes crawl {
    0% {
      /* The element starts below the screen */
      top: 300px;
      /* Rotate the text 20 degrees but keep it close to the viewer */
      transform: rotateX(20deg) translateZ(0);
    }
    100% {
      /* This is a magic number, but using a big one to make sure the text is fully off the screen at the end */
      top: -6000px;
      /* Slightly increasing the rotation at the end and moving the text far away from the viewer */
      transform: rotateX(25deg) translateZ(-2500px);
    }
  }
  .fade {
    position: relative;
    width: 100%;
    min-height: 60vh;
    top: -25px;
    background-image: linear-gradient(0deg, transparent, black 75%);
    z-index: 1;
  }
</style>
